<template>
  <div>
    <iframe :src="url" width="100%" :style="getHeight" scrolling="no" id="iframesection">{{
      $t("notSupportPDF")
    }}</iframe>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: [String, Number],
    },
  },
  data() {
    return {
      file: "",
    };
  },
  computed: {
    url() {
      let langCode = this.$store.getters["account/user"].CultureCode;
      if(langCode == "es"){
        langCode = "es-ES";
      }else if(langCode == "pt"){
        langCode = "pt-PT";
      }

      document.addEventListener("webviewerloaded", function() {
        const PDFViewerApplicationOptions = document.getElementById("iframesection").contentWindow['PDFViewerApplicationOptions'];
        PDFViewerApplicationOptions.set("localeProperties", {lang: langCode});
      }, { once: true });

      return `/js/pdf/web/viewer.html?file=${this.file}`;
    },
    getHeight() {
      if (this.height) return `height: ${this.height}px`;
      else return "height: " + (window.innerHeight - 75 - 68) + "px"; //75px header, 68px footer
    },
  },
  methods: {
    load(file) {
      this.file = file;
    },
  },
};
</script>
